import { call, takeLatest, put } from 'redux-saga/effects';
import { post, get } from '../../helpers/server';

function* getFilterSectors(action) {
    try {
        let fId = action.payload.fId === undefined ? '' : action.payload.fId;
        const resp = yield call(get, "/filter/Info?u=" + action.payload.UserId + "&spk=" + action.payload.stockPoolKey + "&sg=" + action.payload.stockGroups + "&fId=" + fId);
        if (resp.status === 1) {
            if (resp.ff !== undefined && resp.ff !== null) {
                sessionStorage.setItem("FilterFunctionsCache", JSON.stringify(resp.ff));
            }
            if (resp.fs !== null) {
                sessionStorage.setItem("FiltersCache", JSON.stringify(resp.fs));
            }
            if (resp.sg !== null) {
                sessionStorage.setItem("CustomStockGroupsCache", JSON.stringify(resp.sg));
            }
            yield put({ type: "luis_success", sectors: resp.s, stockCount: resp.sc, luString: resp.ls, symbols: resp.ss, filter: resp.f, sourceFilter: resp.sf, filterGroup: resp.fg });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_filter_sectors_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_filter_sectors_fail", status: 0 });
    }
}

function* saveStrategy(action) {
    try {
        yield put({ type: "save_formula_strategy_commit" });
        const resp = yield call(post, "/filter/SaveFilter", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_save_formula_success", editStrategy: resp.editStrategy });
        } else {
            if (resp.status === 4) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_save_formula_fail", status: resp.status, error: resp.error });
        }
    } catch (e) {
        yield put({ type: "get_save_formula_fail", status: 0 });
    }
}

function* addFormulaCustomStock(action) {
    try {
        yield put({ type: "customStock_commit" });
        const resp = yield call(post, "/customStock/Add", action.payload);
        if (resp && resp.status === 1) {
            yield put({ type: 'update_customStock_success', customGroup: resp.customGroup, symbolList: resp.symbolList });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: 'update_customStock_fail', status: resp.status });
        }
    } catch (e) {
        yield put({ type: "update_customStock_fail", status: 0 });
    }
}

function* updateFormulaCustomStock(action) {
    try {
        yield put({ type: "customStock_commit" });
        const resp = yield call(post, "/customStock/update", action.payload);
        if (resp && resp.status === 1) {
            yield put({ type: 'update_customStock_success', customGroup: resp.customGroup, symbolList: resp.symbolList });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: 'update_customStock_fail', status: resp.status });
        }
    } catch (e) {
        yield put({ type: "update_customStock_fail", status: 0 });
    }
}

function* clearFilterString() {
    yield put({ type: 'clear_filter_string' });
}

function* getFilterItems(action) {
    try {
        const resp = yield call(get, "/filter/filterItems?u=" + action.payload.u);
        if (resp.status === 1) {
            if (resp.sg !== null) {
                sessionStorage.setItem("CustomStockGroupsCache", JSON.stringify(resp.sg));
            }
            yield put({ type: "get_filter_items_success", filters: resp.fs });
        } else {
            yield put({ type: "get_filter_items_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_filter_items_fail", status: 0 });
    }
}

function* Effect() {
    yield takeLatest('action_get_filter_sectors', getFilterSectors);
    
    yield takeLatest('action_save_formula_strategy', saveStrategy);

    yield takeLatest('action_add_formula_custom_stock', addFormulaCustomStock);
    yield takeLatest('action_update_formula_custom_stock', updateFormulaCustomStock);

    yield takeLatest('action_clear_filterString', clearFilterString);

    yield takeLatest('action_get_filter_items', getFilterItems);
}

export default Effect;